import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { css } from '@bd/bdui-styles/emotion';


import { H2UnderdogSection } from '../../helpers/UIElements';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import Filters from '../../components/Filters';
import MenuFind from '../../components/MenuFind';
import WelcomeSection from './WelcomeSection';
import AppliedFilters from '../../components/AppliedFilters';
// import InterestedCommunities from '../../components/InterestedCommunities';
import PlansResults from './PlansResults';
// import { grid, colors } from '../../styles';

const styles = css`
  .Plans_sectionWrapper {
    padding: 70px 15px 20px;
  }
  .Plans_sectionTitle {
    font-weight: 300;
    font-size: 30px;
    color: #000000;
    letter-spacing: 0.81px;
    @media(min-width: 992px) {
      font-size: 52px;
      letter-spacing: 1.31px;
      text-align: center;
    }
  }
`;

const sortOptions = [
  { title: 'Name', field: 'name' },
  { title: 'SqFt Low', field: 'sqft' },
  { title: 'SqFt High', field: 'sqft', dir: 'desc' },
];

const filterOptions = [
  {
    type: 'MultiSelect',
    filter: 'Beds',
    title: 'Beds',
    placeholder: 'All Beds',
  },
  {
    type: 'MultiSelect',
    filter: 'Baths',
    title: 'Baths',
    placeholder: 'All Baths',
  },
  {
    type: 'MultiSelect',
    filter: 'Sqft',
    title: 'SQ FT',
    placeholder: 'All SQ FT',
  },
];


const Increment = 16;

class Plans extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sort: sortOptions[2],
      showMap: false,
      showing: 'feed',
      limit: Increment,
    };

    this.setSort = this.setSort.bind(this);
  }

  setSort(sort) {
    let dir = sort.dir || 'asc';
    if (sort.title === this.state.sort.title) {
      dir = this.state.sort.dir === 'desc' ? 'asc' : 'desc';
    }
    this.setState({
      sort: { ...sort, dir },
    });
  }
  setShowMap = showMap => {
    this.setState({
      showMap,
    });
  }
  toggleViewHandler = item => {
    this.setState({ showing: item });
  }
  showMorePlans = () => {
    this.setState({ limit: this.state.limit + Increment });
  }
  render() {
    const { page } = this.props;
    const { sort, showing, limit } = this.state;
    // const areaDescription = get(area, 'name') ? `in the ${get(area, 'name')} area` : '';
    return (
      <PageWrapper noBlog className={styles}>
        <PageHelmet page={page} />
        <InsideHeader
          h1={`${page.metaTags.title}`}
          background={get(page, 'page_image')}
        />
        <MenuFind />
        <WelcomeSection
          lead={get(page, 'welcome_section[0].lead_copy')}
          image={get(page, 'welcome_section[0].image.contentUrl')}
        />
        <div className="Plans_sectionWrapper">
          <H2UnderdogSection className="Plans_sectionTitle">{get(page, 'section_title')}</H2UnderdogSection>
        </div>
        <Filters
          type="plans"
          filterOptions={filterOptions}
          clearButton={<span>Reset Filter <img src="" alt="Reset Filters Icon" /></span>}
          activeSort={sort}
          sortOptions={sortOptions}
          onSortSelect={this.setSort}
          // showMap={showMap}
          toggleView={this.toggleView}
        />
        <div>
          <AppliedFilters
            {...this.props}
            clearButton={<span className="d-none d-md-flex flex align-items-center pr-3 HomesReset_btn">Reset Filters <img src="/images/icons/icon-refresh.svg" alt="reset filters" className="ml-2" /></span>}
            type="homes"
          />
        </div>
        <div className="mt-3">
          <PlansResults
            sort={sort}
            showing={showing}
            limit={limit}
            Increment={Increment}
            showMorePlans={this.showMorePlans}
          />
        </div>
      </PageWrapper>
    );
  }
}

Plans.propTypes = {
  page: PropTypes.object.isRequired,
  // builder: PropTypes.object.isRequired,
  // area: PropTypes.object,
};

Plans.defaultProps = {
  area: undefined,
};

export default withData(
  {
    page: 'plans',
    area: true,
    builder: true,
  },
  {
    required: {
      page: true,
      builder: true,
    },
    ifMissing404: true,
  },
)(Plans);



// WEBPACK FOOTER //
// ./src/pages/Plans/index.js